import { useSubscribedMutation } from '@setvi/shared/hooks';
import { formatProductBody } from 'pages/auto-rfq/utils';
import {
  AutoRFQQueryKey,
  QuotesQueryKey,
  updateAutoRfqItemsMutation
} from 'Services';

export const useUpdateItem = ({
  rfqId,
  triggerApis = [QuotesQueryKey.GET_QUOTE, QuotesQueryKey.GET_PREVIEW]
}: {
  rfqId: string;
  triggerApis?: string[];
}) => {
  const { mutateAsync: updateRfqItems, isLoading: areItemsUpdating } =
    useSubscribedMutation(
      {
        ...updateAutoRfqItemsMutation(),
        onerror: () => {}
      },
      [...triggerApis, AutoRFQQueryKey.GET_RFQ_ANALYTICS]
    );

  const handleItemUpdate = async (p: any) => {
    const matchedProduct =
      p?.matchedInternalProducts?.[p?.internalIndex || 0] || null;

    const productForUpdate = {
      ...formatProductBody({
        competitor: p,
        product: matchedProduct,
        selected: false,
        edit: true,
        fileUrl: p?.fileUrl || ''
      }),
      manualEntry: p?.manualEntry || false,
      prevItemPercentage: p?.prevItemPercentage || 0,
      statusId: p?.statusId,
      _id: p.id,
      isMatched: p?.isMatched,
      matchOverride: p?.matchOverride,
      inQuote: p?.inQuote || false,
      sell: p?.sell || 0,
      ...(p?.cost !== null && p?.cost !== undefined
        ? { cost: p?.cost || 0 }
        : {})
    };

    const res = await updateRfqItems({
      rfqId,
      products: [productForUpdate]
    });

    return res;
  };

  return { handleItemUpdate, areItemsUpdating };
};
